import React, {useState, Fragment, useEffect} from 'react';
import { Card, CardContent } from '@mui/material';
import { Add, NavigateBefore, NavigateNext, Visibility} from '@mui/icons-material';
import Formulario from 'components/formulario';
import TablaPersonalizada from 'components/TablaPersonalizada';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';
import { useDispatch } from 'react-redux';
import { setearDatosAlStore } from 'store/actions/customAction';
import { nombreDeAcciones } from 'constantes/nombreDeAcciones';
import Base64Pdf from 'components/base64pdf';
import { functions } from 'constantes/functions';
let dataToValidate = [];
let cuiSeleccionado = "";

const ListadoPersonaIndividual = ({activeStep, numberStep, listadoPersonaIndividual, idSolicitud}) => {

    const dispatch = useDispatch();

    const [responseData, setResponseData] = useState({ errorType: 'error', messageType: '', openResponse: false, }),
    [listOfCobertura, setListOfCobertura] = useState([]),
    [showModalDeleteOrganization, setShowModalDeleteOrganization] = useState(false),
    [dataItem, setDataItem] = useState({});
    const [docAdjunto, setDocAdjunto] = useState({ title: '', pdf: '' });
    const [mostrarDoc, setMostrarDoc] = useState(false);
    const [formKey, setFormKey] = useState(0);

    const cerrarDoc = () => setMostrarDoc(false);
    const descargarDoc = () => {
        const rawBase64 = docAdjunto.pdf.includes('base64,') ? docAdjunto.pdf.split('base64,')[1] : docAdjunto.pdf;
        functions.descargarBase64EnPDF(rawBase64, `${docAdjunto.title}.pdf`);
    };
    const [header] = useState([
        { title: 'CUI del DPI', field: 'cui', cellStyle:{ maxWidth: '80px'}},
        { title: 'Nombre', field: 'nombreCompleto', cellStyle:{ maxWidth: '80px' }},
        { title: 'Acción', field: 'accion',
        render: rowData=><div style={{minWidth: '100px'}}>
            {
                (<div>
                    {!idSolicitud ? (
                        <TooltipPersonalizado title="Eliminar persona del listado" handleFunction={()=> removerElemento(rowData)} icon="delete" fontSize={30} ></TooltipPersonalizado>
                    ) :  (
                        <TooltipPersonalizado title="Editar persona del listado" handleFunction={() => editarPersonaDelListado(rowData)} icon="edit" fontSize={30} />
                    )}
                </div>)
            }
            </div>
        },
    ]);

    useEffect(() => {
        if(listadoPersonaIndividual.length > 0 ) {
            validarListadoEsMayor(false)
            setListOfCobertura(listadoPersonaIndividual)
        }
    }, []);

    useEffect(() => {
        dataToValidate = listOfCobertura;
    }, [listOfCobertura])

    const validarListadoEsMayor = (disabled) => {
        const newButtonList = Object.assign({}, listadoDeBotones);
        newButtonList.saveData.disabled = disabled
        setButtonList(newButtonList)
    }

    const closeModalDeleteOrganization = () => {
        setShowModalDeleteOrganization(false);
    }

    const editarPersonaDelListado = (rowItem) => {
        let copiaDeElementos = Object.assign({}, elementosDelFormulario )

        cuiSeleccionado = rowItem?.cui || "";
        copiaDeElementos.cui.value = rowItem?.cui || ""
        copiaDeElementos.nombreCompleto.value = rowItem?.nombreCompleto || ""
        copiaDeElementos.pdfDpi.value = rowItem?.pdfDpi;
        copiaDeElementos.pdfDpi.disabledVisualization = !!rowItem?.pdfDpi;
        copiaDeElementos.pdfDpi.handleVisualization = () => {
            const pdfBase64 = rowItem?.pdfDpi || '';
            if (!pdfBase64) return setResponseData({ errorType: 'warning', messageType: 'NO HAY DPI DISPONIBLE PARA VISUALIZAR', openResponse: true });
            setDocAdjunto({ title: `DPI DE LA PERSONA - ${rowItem?.nombreCompleto?.toUpperCase() || ''}`, pdf: pdfBase64 });
            setMostrarDoc(true);
        };
        setCamposDelFormulario(copiaDeElementos);
    }

    const [elementosDelFormulario, setCamposDelFormulario] = React.useState(() => {
        const elementos = {
        PersonaInvidualTitulo:{
            idelement: "PersonaInvidualTitulo",title:'Persona Individual', position:"center", value: "", isError:false, elementType:'title'
        },

        cui:{
            idelement: "cui", value: "", label: "Ingrese CUI del DPI *", pattern:"^[0-9]{13}$", validators: ['required'], errorMessages:['Numérico de 13 digitos'], isError:false, elementType:'texto','disabled': false, autofocus: true, maxLength: 13, name:"cui"
        },

        nombreCompleto: {
            idelement: "nombreCompleto",  value: "", label: "Nombre *",  pattern:"^([a-zA-ZÀ-ÿñÑ\.]{1,})([ ][a-zA-ZÀ-ÿñÑ\.]{1,}){0,}$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'texto', name:"nombreCompleto", autofocus: false,
        },
        pdfDpi:{
            idelement: "pdfDpi", value: "", label: "Ingrese en PDF copia del DPI *",
            validators: {required: true,  size: "10 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"pdfDpi", fileWidth: true, src: '', multiple: false, accept:".pdf", showInMovil: true, type: "file", showButtonEditDocument: true, firstTitle: "certificacionRegistroMercantil", iconButton: <Visibility />, handleVisualization: () => {}, disabledVisualization: false, fileType: "pdf"
        },
        };

        Object.keys(elementos).forEach((key) => {
            if (["texto", "areaTexto"].includes(elementos[key]?.elementType)) {
                elementos[key].transformToUppercase = true;
            }
        });

        return elementos;
    });

    const removerElemento = (rowItem) => {
        setDataItem(rowItem)
        setShowModalDeleteOrganization(true);
    }

    const manejadorActionModal = async () => {
        const {cui} = dataItem;
        const newData = listOfCobertura.filter((item) => item.cui !== cui)

        setListOfCobertura(newData);
        setShowModalDeleteOrganization(false);
        if(newData.length === 0 ) validarListadoEsMayor(true);
    }

    const saveData = async (dataForm) => {
        // Si el usuario adjuntó un DPI en el formulario pero no clickeó "Editar persona",
        // aplicar automáticamente el DPI a la persona que estaba siendo editada.
        let listParaElStore = dataToValidate;
        if (idSolicitud && cuiSeleccionado && dataForm?.pdfDpi) {
            const persona = listParaElStore.find(item => Number(item?.cui) === Number(cuiSeleccionado));
            if (persona) {
                const sinPersonaActual = listParaElStore.filter(item => Number(item?.cui) !== Number(cuiSeleccionado));
                listParaElStore = [...sinPersonaActual, { ...persona, pdfDpi: dataForm?.pdfDpi }];
            }
        }

        await dispatch(setearDatosAlStore({
            dispatchAction : nombreDeAcciones.SET_DATA_INDIVIDUAL_PERSON_LIST,
            data: {
                listadoPersonaIndividual: listParaElStore,
                activeStep : activeStep + 1,
                numberStep : numberStep + 1
            }
        }));
    }

    const agregarAlListado = (dataForm) => {

        if(dataToValidate.length === 5 ) return setResponseData({ errorType: 'warning', messageType: `SOLO PUEDE AGREGAR 5 PERSONAS AL LISTADO!.`, openResponse: true, });

        if(!idSolicitud && dataToValidate.length > 0 ) {
            const existElement = dataToValidate.some((item) => Number(item.cui) === Number(dataForm?.cui))
            if(existElement) return setResponseData({ errorType: 'warning', messageType: `LA PERSONA YA FUE AGREGADA AL LISTADO!.`, openResponse: true, });
        }

        listadoDeBotones.saveData.disabled = false;

        if(idSolicitud) {
            let listadoEditado = []
            const existePersona = dataToValidate.some( (item) => Number(item?.cui) === Number(cuiSeleccionado) )

            if(existePersona) {
                const personasFiltradas = dataToValidate.filter( (item) => Number(item?.cui) !== Number(cuiSeleccionado) )
                listadoEditado = [...personasFiltradas, {
                    id: dataForm?.cui,
                    cui: dataForm?.cui,
                    pdfDpi: dataForm?.pdfDpi,
                    cuiNuevo: cuiSeleccionado,
                    nombreCompleto: dataForm?.nombreCompleto
                }]
            } else {
                listadoEditado = [...dataToValidate, {
                    id: dataForm?.cui,
                    cui: dataForm?.cui,
                    pdfDpi: dataForm?.pdfDpi,
                    cuiNuevo: dataForm?.cui,
                    nombreCompleto: dataForm?.nombreCompleto
                }]
            }

            setListOfCobertura( listadoEditado )
        }
        else setListOfCobertura( prevState => [...prevState, { id: dataForm?.cui, pdfDpi: dataForm?.pdfDpi, cui:dataForm?.cui, nombreCompleto: dataForm?.nombreCompleto, }])

        const elementosReiniciados = functions.reiniciarEstadoDelFormulario({ ...elementosDelFormulario });
        setCamposDelFormulario({ ...elementosReiniciados });
        setFormKey(prev => prev + 1);
        cuiSeleccionado = "";
    };

    const accionRegresar = () => {
        dispatch(setearDatosAlStore({
            dispatchAction : nombreDeAcciones.SET_DATA_INDIVIDUAL_PERSON_LIST,
            data: {
                listadoPersonaIndividual: dataToValidate,
                activeStep,
                numberStep
            }
        }));

        dispatch(setearDatosAlStore({
            dispatchAction : nombreDeAcciones.SET_DATA_ACTIVE_AND_NUMBER_STEP,
            data: {
                activeStep : activeStep - 1,
                numberStep : numberStep - 1
            }
        }));
    };

  // elements button action to show of the form
    const [listadoDeBotones, setButtonList]= React.useState({
        "accionRegresar":{"label":"Regresar", "icon": <NavigateBefore />,"callback":accionRegresar,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false, isCancel: true,
        },
        "agregarAlListado":{"label": idSolicitud ? "Editar persona" : "Agregar al listado" , "icon": <Add />,"callback":agregarAlListado,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #ffcc00 30%, #d9bd09 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(168, 142, 50, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false, isCancel: false,
        },
        "saveData":{"label":"Siguiente", "icon": <NavigateNext />, "callback":saveData,"loading":false,"size":"medium",
        "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
        "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: true, isCancel: true, sendWithoutValidForm: true
        },
    });

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('warning', '', false)
    };

    const changeDataResponse = (errorType, messageType, openResponse = false) => {
        setResponseData({ errorType, messageType, openResponse, })
    };

    const { errorType, messageType, openResponse} = responseData;

    return (
        <Fragment>
            <AlertaDeRespuesta type={errorType} content={messageType} open={openResponse} handClose={handClose}/>
            <Card>
                <CardContent>
                    <Formulario
                        key={formKey}
                        elements={elementosDelFormulario}
                        buttonList={listadoDeBotones}
                    />
                    <TablaPersonalizada
                        showPagination={true}
                        data={listOfCobertura}
                        title={"Listado de personas"}
                        header={header}
                        detailPanel={[]}
                    />
                </CardContent>
            </Card>
            {showModalDeleteOrganization && (
                <ModalDeConfirmacion
                    title={`¿Está seguro de eliminar a la persona?`} message={"No podrá revertir esta acción"}
                    open={showModalDeleteOrganization} closeModal={closeModalDeleteOrganization} titleButton={"Sí, estoy seguro"}
                    actionAdd={manejadorActionModal}
                />
            )}
            {mostrarDoc && (
                <Base64Pdf pdf={docAdjunto.pdf} title={docAdjunto.title} open={mostrarDoc} handleClose={cerrarDoc} showDownloadButton={true} DescargarPDF={descargarDoc} />
            )}
        </Fragment>
    );
}

export default ListadoPersonaIndividual;